import { createSlice } from "@reduxjs/toolkit";
import { createReview, deleteReview, fetchReviews, updateReview } from "./googleReviewBaseApi";
const reviewsSlice = createSlice({
    name: "reviews",
    initialState: {
      reviews: [],
      status: "idle",
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchReviews.pending, (state) => {
          state.status = "loading";
        })
        .addCase(fetchReviews.fulfilled, (state, action) => {
          state.status = "succeeded";
          state.reviews = action.payload;
        })
        .addCase(fetchReviews.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.error.message;
        })
        .addCase(createReview.fulfilled, (state, action) => {
          state.reviews.push(action.payload);
        })
        .addCase(updateReview.fulfilled, (state, action) => {
          const index = state.reviews.findIndex((item) => item.id === action.payload.id);
          if (index !== -1) {
            state.reviews[index] = action.payload;
          }
        })
        .addCase(deleteReview.fulfilled, (state, action) => {
          state.reviews = state.reviews.filter((item) => item.id !== action.payload);
        });
    },
  });
  
  export default reviewsSlice.reducer;